import { useEffect, useState, useRef } from 'react'

const useNearElement = ({
  distance = '100px',
  once = true,
  externalRef = undefined,
} = {}) => {
  const [isNearElement, setIsNearElement] = useState(false)
  const fromRef = useRef()

  useEffect(() => {
    let observer

    const element = externalRef ? externalRef.current : fromRef.current

    const onChange = (entries, observer) => {
      const el = entries[0]
      if (el.isIntersecting) {
        setIsNearElement(true)
        once && observer.disconnect()
      } else {
        !once && setIsNearElement(false)
      }
    }

    Promise.resolve(
      typeof IntersectionObserver !== 'undefined'
        ? IntersectionObserver
        : import('intersection-observer'),
    ).then(() => {
      observer = new IntersectionObserver(onChange, {
        rootMargin: distance,
      })

      if (element) observer.observe(element)
    })

    return () => observer && observer.disconnect()
  })

  return { isNearElement, fromRef }
}

export default useNearElement
